/* assets/resources-home.js — Resources page behaviour. */
(function(){
    /* CTA anchors that only resolve on the home page -> real destinations */
    document.querySelectorAll('a[href="#shop"]').forEach(function(a){ a.setAttribute('href','/#shop'); });
    document.querySelectorAll('a[href="#contact"]').forEach(function(a){ a.setAttribute('href','/pages/contact'); });

    /* "Load more guides": reveal hidden cards; if none exist, hide the button (all guides already shown) */
    var moreWrap=document.querySelector('.rmore');
    var moreBtn=moreWrap && moreWrap.querySelector('button');
    function hiddenCards(){ return [].slice.call(document.querySelectorAll('.rsrc__grid .rsrc__card.is-hidden, .rsrc__grid .rsrc__card[hidden]')); }
    if(moreBtn){
      if(hiddenCards().length===0){ moreWrap.style.display='none'; }
      else {
        moreBtn.addEventListener('click', function(){
          hiddenCards().slice(0,6).forEach(function(c){ c.classList.remove('is-hidden'); c.removeAttribute('hidden'); });
          if(hiddenCards().length===0){ moreWrap.style.display='none'; }
        });
      }
    }

    /* newsletter subscribe -> Shopify customer (marketing) signup via AJAX */
    document.querySelectorAll('.rnews__form').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var input=form.querySelector('input[type=email]');
        var email=input && input.value.trim();
        if(!email){ if(input) input.focus(); return; }
        var data=new URLSearchParams();
        data.append('form_type','customer'); data.append('utf8','\u2713');
        data.append('contact[email]',email); data.append('contact[tags]','newsletter,virtual-firewall');
        fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded',Accept:'text/html'},body:data.toString()})
          .then(function(){ form.innerHTML='<p class="rnews__ok" style="margin:0;font-weight:600">Thanks \u2014 you\u2019re subscribed.</p>'; })
          .catch(function(){ form.innerHTML='<p class="rnews__ok" style="margin:0;font-weight:600">Thanks \u2014 we\u2019ll be in touch.</p>'; });
      });
    });
  })();
